import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chevron-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ec761a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "my-page-container" }
const _hoisted_3 = { class: "hello" }
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "님 안녕하세요", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "회원정보 수정", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_9 = {
  class: "body",
  ref: "scrollContainerRef"
}
const _hoisted_10 = { class: "menu-container" }
const _hoisted_11 = { class: "menu-section" }
const _hoisted_12 = {
  class: "menu-navigation",
  role: "navigation",
  "aria-label": "주요 서비스"
}
const _hoisted_13 = { class: "menu-list" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider",
  role: "separator",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_16 = { class: "history-section" }
const _hoisted_17 = {
  class: "menu-navigation",
  role: "navigation",
  "aria-label": "이용 내역"
}
const _hoisted_18 = { class: "menu-list" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider",
  role: "separator",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_25 = { class: "support-section" }
const _hoisted_26 = {
  class: "menu-navigation",
  role: "navigation",
  "aria-label": "고객 지원"
}
const _hoisted_27 = { class: "menu-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "back-button",
          onClick: $setup.onClickBack,
          "aria-label": "이전 페이지로 돌아가기"
        }, [
          _createVNode($setup["InlineSvg"], {
            src: require('@/assets/icons/x-icon.svg'),
            "aria-hidden": "true"
          }, null, 8 /* PROPS */, ["src"])
        ])
      ]),
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("header", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString($setup.alias), 1 /* TEXT */),
            _hoisted_5
          ]),
          _createVNode(_component_router_link, {
            to: { name: $setup.RouterName.MyInfo },
            class: "edit-my-info",
            "aria-label": "회원정보 수정 페이지로 이동"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("section", _hoisted_11, [
              _createElementVNode("nav", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.LineSearch },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 노선 검색 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.MapOfNearbyBusStops },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 정류장 검색 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.InsideShuttleMap },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 사내셔틀 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  ($setup.busStopLayouts.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createVNode(_component_router_link, {
                          to: { name: $setup.RouterName.BusStopLayout },
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 승강장 배치도 ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.NewRouteApplicationList },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 신규 노선/정류장 신청 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.RouteDemandSurvey },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 노선 수요조사 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ])
                ])
              ])
            ]),
            _hoisted_15,
            _createElementVNode("section", _hoisted_16, [
              _createElementVNode("nav", _hoisted_17, [
                _createElementVNode("ul", _hoisted_18, [
                  ($setup.bookRequiredType === $setup.BookRequiredType.BOOK_REQUIRED)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: { name: $setup.RouterName.BookHistory },
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 예약내역 ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : ($setup.bookRequiredType === $setup.BookRequiredType.MIXED)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            to: { name: $setup.RouterName.BookBoardHistory },
                            class: "menu-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 탑승현황 ")
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["to"])
                        ]))
                      : _createCommentVNode("v-if", true),
                  ($setup.bookRequiredType === $setup.BookRequiredType.NO_BOOK_REQUIRED)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: { name: $setup.RouterName.BoardHistory },
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 탑승내역 ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.serviceInfo?.shouldShowPayLog)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          to: { name: $setup.RouterName.PaymentHistory },
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 결제내역 ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.ReportHistory },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 신고내역 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  ($setup.serviceInfo?.shouldShowLostAndFound)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createVNode(_component_router_link, {
                          to: { name: $setup.RouterName.LostFoundList },
                          class: "menu-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 분실물센터 ")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _hoisted_24,
            _createElementVNode("section", _hoisted_25, [
              _createElementVNode("nav", _hoisted_26, [
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.Notice },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 공지사항 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.VocList },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 문의하기 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.BusCompanyList },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 전세버스 문의 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.Contact },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 고객지원 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: $setup.RouterName.UsageGuide },
                      class: "menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 이용안내 ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            ref: "logoutBtn",
            class: "logout",
            onClick: $setup.goToMainLogout
          }, " 로그아웃 ", 512 /* NEED_PATCH */),
          _createElementVNode("footer", null, [
            _createVNode($setup["CompanyInfo"], {
              termsList: $setup.termsList,
              onOnClickTerms: $setup.onClickTerms
            }, null, 8 /* PROPS */, ["termsList"])
          ])
        ], 512 /* NEED_PATCH */)
      ]),
      ($setup.scrollContainerRef)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.scrollContainerRef
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTerms,
        onBackHandler: () => $setup.toggleShowTerms(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TermsDetail"], {
            class: "terms-container",
            title: $setup.selectedTerms?.title ?? '',
            url: $setup.selectedTerms?.url ?? '',
            onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowTerms(false)))
          }, null, 8 /* PROPS */, ["title", "url"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}